import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-input-currency',
  templateUrl: './input-currency.component.html',
  styleUrls: ['./input-currency.component.scss']
})
export class InputCurrencyComponent implements OnInit {

  @Input() public currency: any = '';
  @Input() public error: any;
  @Input() public disabled: any;
  @Input() public preffix: any;
  @Output() callback: EventEmitter<any> = new EventEmitter;
  @Output() focusout: EventEmitter<any> = new EventEmitter;
  noValid:any;


  constructor() { 
    this.noValid=false;}

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.currency && changes.currency.currentValue) {
      this.format();
    }
  }

  onNgModelChanges($event) {
    this.format();
    this.emit();
  }

  format() {
    if (!this.currency) {
      return '';
    }
    this.noValid = false;
    
    if(this.currency.toString().indexOf('.') > 0)
    {
      var cadena = this.currency.toString(),separador = ".",arregloDeSubCadenas = cadena.split(separador);
              var cadena1 = arregloDeSubCadenas[1];
              if(cadena1 > 99){
                this.noValid = true;
              }
    }
    this.currency = this.currency.toString().replace(/\B(?=(\d{3})+(?!\d{3})+(?!\d))/g, ",");

  }

  getUnformat() {
    const currencyUnformat = this.currency.replace(/,/g,'');
    return currencyUnformat;
  }

  emit() {
    this.callback.emit(this.getUnformat());
  }

  public onFocusOut(event){
    this.focusout.emit(this.currency);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/tools/input-currency/input-currency.component.ts